// eslint-disable-next-line no-restricted-imports
import { useFlags } from 'launchdarkly-react-client-sdk';

/**
 * Flags that are temporary and should be removed after a certain date.
 *
 * If you need are adding a permanent flag, add it to `useFlags` instead.
 */
export type TemporaryFeatureFlags = {
  /**
   * Added on March 27, 2025
   */
  contentCollection: boolean;
  /**
   * Added on June 14th, 2023
   */
  savedFilters: boolean;
  /**
   * Added on April 11, 2025
   */
  searchImprovements: boolean;
  /**
   * Added on May 2, 2025
   */
  colorFilter: boolean;
  /**
   * Added on May 12, 2025
   */
  assetModalImprovements: boolean;
};

export const useTemporaryFeatureFlags = () => useFlags<TemporaryFeatureFlags>();
